import { editCustomerSchema } from '../schema/editCustomerSchema'
import { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import moment from 'moment-jalaali'
import { getData } from '../assets/scripts/GeneralFunctions'
import { errorList } from './stateList'

export const userModalSubmit = async (
  setIsSubmit,
  inputs,
  setCustomer,
  setUserResult,
  setShowModal,
  error,
  setError
) => {
  try {
    const value = await editCustomerSchema.validate(inputs, { abortEarly: false })
    const date = new DateObject({
      date: value?.birth_date,
      calendar: persian,
      locale: persian_fa,
    })

    const birthDate = moment(
      `${date.getValue('YYYY')}-${date.getValue('MM')}-${date.getValue('DD')}`,
      'jYYYY-jMM-jDD'
    ).format('YYYY-MM-DD')

    const obj = value?.birth_date
      ? {
          ...value,
          birth_date: birthDate,
        }
      : {
          ...value,
        }

    const apiResult = await getData(`admin/customers/create`, 'post', obj, true)

    setIsSubmit(false)

    if (apiResult?.status === 200) {
      setShowModal(false)
      setCustomer(apiResult?.data?.customer)
      setUserResult(true)
    } else {
      setError(apiResult?.error)
    }
  } catch (err) {
    setIsSubmit(false)
    setError({
      ...error,
      ...errorList(err),
    })
  }
}
